import { inject } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { NotificationService } from '../services/notification.service';
import { ApiResponse } from '../interfaces/api-response.interface';
import { MsalAuthService } from '../services/msal-auth.service';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const auth = inject(AuthService);
  const msalAuth = inject(MsalAuthService);
  const notify = inject(NotificationService);

  const token = msalAuth.isSSOUser() ? msalAuth.getSSOToken() : auth.getToken();
  const authReq = token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;

  return next(authReq).pipe(
    map(event => {
      if (event instanceof HttpResponse) {
        const body = event.body as ApiResponse | undefined;
        if (body && typeof body.isSuccess === 'boolean') {
          if (!body.isSuccess) {
            notify.error(body.message ?? 'Request failed');
            throw new HttpErrorResponse({
              error: body,
              status: body.status ?? 400,
              statusText: body.message ?? 'Server error',
              url: event.url ?? req.url,
            });
          }
        }
      }
      return event;
    }),
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401 && auth.getToken()) {
          notify.error('Session expired. Please sign in again.');
          auth.logout();
        } else {
          notify.error(err?.error?.message || 'Something went wrong');
        }
      } else {
        notify.error('Unexpected error occurred');
      }
      return throwError(() => err);
    })
  );
};